module.exports = __webpack_public_path__ + "fonts/icomoon_rrss.woff";


//////////////////
// WEBPACK FOOTER
// ./src/styles/fonts/icomoon_rrss/icomoon_rrss.woff
// module id = 5V6k
// module chunks = 1